document.addEventListener('DOMContentLoaded', function() {
  const sortLabel = document.querySelector('.sort-label');
  const sortDropdown = document.getElementById('sort-list');
  const sortOptions = document.querySelectorAll('.sort-option');

  if (!sortLabel || !sortDropdown) return;

  function toggleSort(event) {
    event.stopPropagation();
    const isExpanded = sortLabel.getAttribute('aria-expanded') === 'true';
    sortLabel.setAttribute('aria-expanded', !isExpanded);
    sortDropdown.classList.toggle('is-open');
  }

  sortLabel.addEventListener('click', toggleSort);

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (!sortDropdown.contains(e.target) && !sortLabel.contains(e.target)) {
      sortLabel.setAttribute('aria-expanded', 'false');
      sortDropdown.classList.remove('is-open');
    }
  });

  // Handle sort option selection
  sortOptions.forEach(option => {
    option.addEventListener('click', () => {
      const value = option.dataset.value;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      window.location.href = url.toString();
    });
  });
});
